import React, {useState} from "react";
import { AppDispatch } from "../../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { deleteUserGroup } from "../../../../redux/actions/userGroups.actions";
import RootState from "../../../../redux/states/root.state";
import ModalShell, { ModalLoading } from "../../../../components/common/Modals/ModalShell";
import { clearError } from "../../../../redux/reducers/userGroup.reducer";

interface ModalProps {
    open: boolean;
    setOpen: any;
    userGroup: any;
    params?: string;
}

const DeleteUserGroupModal: React.FC<ModalProps> = ({open, setOpen, userGroup, params=""}) => {
  const dispatch: AppDispatch = useDispatch();
  // deleteUserGroup's loading and error live on the single userGroup slice, not the list slice.
  const {loading: userGroupLoading, error: userGroupError} = useSelector((state: RootState) => state.userGroup);
  const [submitted, setSubmitted] = useState(false);
  const [success, setSuccess] = useState(false);
  // Only reflect this modal's own request, not the page's fetches on the same slice.
  const loading = submitted && userGroupLoading;
  const error = submitted ? userGroupError : null;

  const handleClose = () => {
    dispatch(clearError());
    setSubmitted(false);
    setSuccess(false);
    setOpen(false);
  };

  const handleDelete = async () => {
    if(userGroup){
      setSubmitted(true);
      const result = await dispatch(
          deleteUserGroup({id:userGroup.id})
      );

      setSuccess(deleteUserGroup.fulfilled.match(result));
    }
  }

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={loading}
      tone={loading ? undefined : error ? "error" : success ? "success" : "warning"}
      title={
        loading ? "Deleting…"
        : error ? "An error occurred"
        : success ? "User group deleted"
        : <>Delete user group <b>{userGroup?.name}</b>?</>
      }
      actions={loading ? undefined : error || success ?
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
        :
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
        </>
      }
    >
      {loading ?
        <ModalLoading/>
        : error ?
        <p>An error occurred while deleting, please try again later.</p>
        : success ?
        <p>User group successfully deleted.</p>
        :
        <p>This action cannot be undone.</p>
      }
    </ModalShell>
  );
};

export default DeleteUserGroupModal;
